/** @jsxImportSource @emotion/react */

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { EmptyButton } from 'modules/template-editor/ui/components/editor/right-toolbar/styles';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import UDText from 'ud-ui/components/text';
import { setCurrentDate } from '../../../../../store';
import { selectCurrentDate } from '../../../../../store/selectors';
import { ButtonStyles } from './styles';

function Header() {
  const dispatch = useDispatch<AppDispatch>();
  const { month: currentMonth, year: currentYear } = useSelector(selectCurrentDate);
  const date = new Date(currentYear, currentMonth);
  const nextMonth = useCallback(() => {
    const year = currentMonth === 11 ? currentYear + 1 : currentYear;
    const month = currentMonth === 11 ? 0 : currentMonth + 1;
    dispatch(setCurrentDate({ month, year }));
  }, [currentMonth, currentYear, dispatch]);
  const prevMonth = useCallback(() => {
    const year = currentMonth === 0 ? currentYear - 1 : currentYear;
    const month = currentMonth === 0 ? 11 : currentMonth - 1;
    dispatch(setCurrentDate({ month, year }));
  }, [currentMonth, currentYear, dispatch]);

  return (
    <div className={'flex justify-between'}>
      <div>
        <UDText type={'subhead'} style={{ textTransform: 'uppercase' }}>
          {date.toLocaleString('ru-RU', { month: 'long' })} {date.toLocaleString('ru-RU', { year: 'numeric' })}
        </UDText>
      </div>
      <div className={'flex'} style={{ gap: 16 }}>
        <EmptyButton onClick={prevMonth} css={ButtonStyles}>
          <ChevronLeft size={21} />
        </EmptyButton>
        <EmptyButton onClick={nextMonth} css={ButtonStyles}>
          <ChevronRight size={21} />
        </EmptyButton>
      </div>
    </div>
  );
}

export default Header;
